import { withJsonFormsControlProps } from '@jsonforms/react';
import { ContactNumber } from './ContactNumber';

const ContactNumberControl = ({ data, handleChange, path, schema, errors, visible, label }) => {
  return (
    <ContactNumber
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      description={schema?.description ?? ''}
      errors={errors}
      visible={visible}
      label={label}
    />
  );
};

export default withJsonFormsControlProps(ContactNumberControl);
